import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import IRhere_Logo from "../../../assets/irhere_images/Group 389.png";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const SearchValidation = () => {
  const [searchInput, setSearchInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [emptyData, setEmptyData] = useState(false);

  // For now, we'll use a placeholder token - you may need to get this from localStorage or context
  const token = localStorage.getItem("access_token") || "";

  // Auto-focus the search input when component mounts
  useEffect(() => {
    const searchInputElement = document.querySelector(".searchInput");
    if (searchInputElement) {
      searchInputElement.focus();
    }
  }, []);

  /**
   * Detects if the current browser is Safari
   * @returns {boolean} True if the browser is Safari
   */
  const isSafari = () => {
    const userAgent = navigator.userAgent;
    return /^((?!chrome|android).)*safari/i.test(userAgent);
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (value === "") {
      setEmptyData(false);
    }
  };

  const handleSubmit = async () => {
    document.getElementById("ValidationError").innerHTML = "";

    if (searchInput === "") {
      toast.error("Enter Validation Number before searching.");
    } else {
      try {
        setLoading(true);
        setEmptyData(false);

        // Auto-append "V" if not already present
        let processedSearchInput = searchInput.trim();
        if (!processedSearchInput.toUpperCase().startsWith("V")) {
          processedSearchInput = "V" + processedSearchInput;
        }

        const bodyFormData = new FormData();
        bodyFormData.append("search_ver_id", processedSearchInput);

        // Direct API call without Redux
        const response = await axios({
          method: "post",
          url: "https://geoface.com.au/api/admin/certificates/search",
          data: bodyFormData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            mode: "cors",
          },
        });

        const responseData = response.data;

        // Check if we have certificate data
        if (
          responseData &&
          responseData.certificates &&
          responseData.certificates.length > 0
        ) {
          const certificates = responseData.certificates;

          // Check if data is empty or not
          if (certificates.length === 0) {
            setEmptyData(true);
          } else if (certificates.length > 1) {
            document.getElementById("ValidationError").innerHTML =
              "Please enter a proper validation number.";
          } else {
            document.getElementById("ValidationError").innerHTML = "";
            // Use the provided URL from the response if available, or fall back to the specified URL pattern

            const navigateTo = certificates[0]?.url
              ? certificates[0].url
              : `https://geoface.com.au/verify?id=${certificates[0]?.ver_id}`;

            if (!isSafari()) {
              window.open(navigateTo);
              return;
            }

            // Open the certificate URL in a new tab
            const newWindow = window.open(
              navigateTo,
              "_blank",
              "noopener,noreferrer"
            );
            // Fallback for Safari if popup is blocked
            if (
              !newWindow ||
              newWindow.closed ||
              typeof newWindow.closed === "undefined"
            ) {
              // For Safari, navigate in same tab as fallback
              window.location.href = navigateTo;
            }
          }
        } else {
          setEmptyData(true);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        toast.error("Error fetching certificate data");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <div className="container-xxl flex-grow-1 d-flex justify-content-center">
        <div className="searchvalidation">
          <div className="logo d-flex align-items-center gap-3">
            <Link to="https://geoface.com.au/" target="_blank">
              <img
                src={IRhere_Logo}
                alt="auth-login-cover"
                className="rounded-2"
              />
            </Link>
          </div>
          <div className="Inputcontainer card">
            <div
              className="searchInputWrapper"
              style={{ position: "relative" }}
            >
              <input
                className="searchInput"
                type="text"
                placeholder=""
                value={searchInput}
                onChange={handleSearchInputChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit();
                  }
                }}
              />
              {!searchInput && (
                <div
                  className="search-bar-placeholder"
                  style={{
                    position: "absolute",
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#6c757d",
                    pointerEvents: "none",
                    fontSize: "30px",
                    paddingLeft: "20px",
                  }}
                >
                  Type the Validation Number here to search
                </div>
              )}
              <i
                className="searchInputIcon fa fa-search"
                style={{ cursor: "pointer" }}
                onClick={handleSubmit}
              ></i>
            </div>
          </div>
          {/* Show loading spinner */}
          {loading && (
            <div className="p-4 my-4 w-100 text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          {/* Show "No records found" message */}
          {emptyData && !loading && (
            <div className="p-4 my-4 w-100 text-center">
              <div className="show text-danger fw-bold">No records found !</div>
            </div>
          )}
          <div className="p-4 my-4 w-100 text-center">
            <div id="ValidationError" className="text-danger fw-bold"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchValidation;
